<template>
  <v-container grid-list-md class="no-padding">
    <v-layout wrap>
      <v-flex xs12>
        <v-card class="user">
          <v-card-title>
            <h2 v-if="editMode" class="user__name">Uredi profil</h2>
            <h2 v-else class="user__name">{{ user.first_name }} {{ user.last_name }}</h2>
            <v-icon class="user__icon">{{ userIcon }}</v-icon>
            <span class="user__uid">{{ userId }}</span>
          </v-card-title>

          <v-card-text v-if="editMode">
            <form @submit.prevent="saveProfile">
              <p>
                <v-text-field
                  name="first_name"
                  label="Ime"
                  id="first_name"
                  type="text"
                  v-model="user.first_name"
                  required></v-text-field>
              </p>
              <p>
                <v-text-field
                  name="last_name"
                  label="Priimek"
                  id="last_name"
                  type="text"
                  v-model="user.last_name"
                  required></v-text-field>
              </p>
              <p>
                <v-text-field
                  name="email"
                  label="Email"
                  id="email"
                  type="email"
                  v-model="user.email"
                  required></v-text-field>
              </p>
              <p>
                <v-text-field
                  name="phone"
                  label="Telefon"
                  id="phone"
                  type="phone"
                  v-model="user.phone"
                  required></v-text-field>
              </p>
              <p>
                <v-text-field
                  name="car"
                  label="Avto"
                  id="car"
                  type="text"
                  v-model="user.car"></v-text-field>
              </p>
              <p>
                <v-text-field
                  name="trr"
                  label="TRR"
                  id="trr"
                  type="text"
                  v-model="user.trr"></v-text-field>
              </p>
              <p>
                <v-text-field
                  name="vat"
                  label="Davčna"
                  id="vat"
                  type="text"
                  v-model="user.vat"></v-text-field>
              </p>
              <p>
                <v-btn @click="editMode = false">Prekliči</v-btn>
                <v-btn type="submit" color="primary">Shrani</v-btn>
              </p>
            </form>
          </v-card-text>

          <v-card-text v-else>
            <p v-if="user.function">funkcija: {{ user.function }}</p>
            <p v-if="user.phone">telefon: {{ user.phone }}</p>
            <p v-if="user.email">email: {{ user.email }}</p>
            <p v-if="user.vat">davčna: {{ user.vat }}</p>
            <p v-if="user.car">avto: {{ user.car }}</p>
            <p v-if="user.trr">TRR: {{ user.trr }}</p>
            <p v-if="!changingPassword && (enableEdit || enableLogout)">
              <v-btn v-if="enableEdit" @click="editProfile">Uredi podatke</v-btn>
              <v-btn v-if="enableEdit" @click="changingPassword = true">Spremeni geslo</v-btn>
              <v-btn v-if="enableLogout" @click="logout" color="info">Odjavi se</v-btn>
            </p>
            <div v-if="changingPassword">
              <form @submit.prevent="updatePassword">
                <p>
                  <v-text-field
                    name="old_pass"
                    label="Trenutno geslo"
                    id="old_pass"
                    type="password"
                    v-model="passwords.old_pass"></v-text-field>
                </p>
                <p>
                  <v-text-field
                    name="new_pass"
                    label="Novo geslo"
                    id="new_pass"
                    type="password"
                    v-model="passwords.new_pass"></v-text-field>
                </p>
                <p><v-btn type="submit" color="primary">Spremeni</v-btn></p>
              </form>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase';
import db from '../components/firebaseInit';

export default {
  name: 'profile',

  data() {
    return {
      user: {},
      currUser: {},
      passwords: {},
      changingPassword: false,
      dbDoc: '',
      userId: '',
      userIcon: '',
      editMode: false,
      enableEdit: false,
      enableLogout: false,
    };
  },

  created() {
    this.getUser();
  },

  methods: {
    getUser() {
      this.currUser = firebase.auth().currentUser;
      const currUserDoc = db.collection('users').doc(this.currUser.uid);
      currUserDoc.get().then((doc) => {
        const currUserData = doc.data();
        if (currUserData.userLevel === 'admin') {
          this.enableEdit = true;
        }
      });
      this.userId = this.$route.params.id;
      if (this.currUser.uid === this.userId) {
        this.enableLogout = true;
        this.enableEdit = true;
      }
      this.dbDoc = db.collection('users').doc(this.userId);
      this.dbDoc.get().then((user) => {
        this.user = user.data();
        if (this.user.userLevel === 'admin') {
          this.userIcon = 'star';
        } else {
          this.userIcon = 'person';
        }
      });
    },

    editProfile() {
      this.editMode = true;
    },

    saveProfile() {
      this.editMode = false;
      this.dbDoc
        .set(this.user)
        .then(() => {
          console.log('Document successfully written.');
        })
        .catch((error) => {
          console.error('Error writing document: ', error);
        });
    },

    updatePassword() {
      this.changingPassword = false;
      console.log(this.passwords);
      firebase.auth().signInWithEmailAndPassword(this.currUser.email, this.passwords.old_pass)
        .then(() => {
          this.currUser.updatePassword(this.passwords.new_pass)
            .then(() => {
              console.log('Password changed');
            }).catch((error) => {
              console.log('Password reset failed: ', error);
            });
        }).catch((error) => {
          console.log('Re-auth failed: ', error);
        });
    },

    logout() {
      firebase.auth().signOut().then(() => {
        console.log('you logged out');
        this.$router.go({ path: this.$router.path });
      });
    },
  },
};
</script>

<style lang="scss">
  .color-grey {
    opacity: 0.5;
  }
  .user {
    &__name {
      margin-right: 20px;
    }

    &__icon {
      display: inline-block;
      margin-right: 20px;
    }

    &__uid {
      display: inline-block;
      opacity: 0.5;
    }
  }
</style>
